import { render, staticRenderFns } from "./ClientContactsModal.vue?vue&type=template&id=c2643f20&scoped=true"
import script from "./ClientContactsModal.vue?vue&type=script&lang=js"
export * from "./ClientContactsModal.vue?vue&type=script&lang=js"
import style0 from "./ClientContactsModal.vue?vue&type=style&index=0&id=c2643f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2643f20",
  null
  
)

export default component.exports